import { ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { tap, debounceTime, filter } from 'rxjs/operators';
import { NumberUtils } from '../../../../utils/number.utils';
import { UserService } from '../../../../services/user.service';
import { chartConfig } from '../../../../app.constants';
var FollowerByChannelComponent = /** @class */ (function () {
    function FollowerByChannelComponent(cd, userService) {
        var _this = this;
        this.hasNoData = false;
        this.readyToShow = false;
        this.chartConfig = {
            spacingTop: 0,
            spacingRight: 0
        };
        this.overridenPiePlotOptions = {
            borderWidth: 0
        };
        this.legend = {
            useHTML: true,
            y: 0,
            navigationActiveColor: '#445166',
            navigationInactiveColor: 'rgba(68,81,102,0.50)',
            navigationArrowSize: 10,
            itemHiddenStyle: { color: 'rgba(68, 81, 102, 0.05)' },
            x: 87,
            align: 'center',
            floating: true
        };
        this.placeholderData = [
            {
                name: 'Instagram',
                y: 0.2,
                color: 'rgba(149,160,177, 0.1)',
                customLegendDisplay: '- K'
            },
            {
                name: 'YouTube',
                y: 0.2,
                color: 'rgba(149,160,177, 0.1)',
                customLegendDisplay: '- K'
            },
            {
                name: 'Blogs',
                y: 0.2,
                color: 'rgba(149,160,177, 0.1)',
                customLegendDisplay: '- K'
            },
            {
                name: 'Tiktok',
                y: 0.2,
                color: 'rgba(149,160,177, 0.1)',
                customLegendDisplay: '- K'
            }
        ];
        this._selectedColor = userService.chartColors[0];
        this._channelFollowersSubject = new Subject();
        this._selectedChannelIdSubject = new Subject();
        this._changeSubscription = combineLatest([
            this._channelFollowersSubject,
            this._selectedChannelIdSubject
        ]).pipe(filter(function (_a) {
            var channelFollowers = _a[0], selectedChannelId = _a[1];
            return channelFollowers !== undefined && selectedChannelId !== undefined;
        }), tap(function () {
            _this.readyToShow = false;
            cd.detectChanges();
        }), debounceTime(100)).subscribe({
            next: function (_a) {
                var channelFollowers = _a[0], selectedChannelId = _a[1];
                _this.readyToShow = true;
                if (!Array.isArray(channelFollowers)
                    || channelFollowers.length === 0
                    || !channelFollowers.find(function (c) { return c.channelId === selectedChannelId; })) {
                    _this.hasNoData = true;
                    return;
                }
                _this.hasNoData = false;
                _this.chartData = _this.getChartData(channelFollowers, selectedChannelId);
            }
        });
    }
    Object.defineProperty(FollowerByChannelComponent.prototype, "channelFollowers", {
        set: function (value) {
            this._channelFollowersSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FollowerByChannelComponent.prototype, "selectedChannelId", {
        set: function (value) {
            this._selectedChannelIdSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    FollowerByChannelComponent.prototype.ngOnDestroy = function () {
        this._changeSubscription.unsubscribe();
    };
    FollowerByChannelComponent.prototype.getChartData = function (channelFollowers, selectedChannelId) {
        var _this = this;
        var drawnChannelFollowers = channelFollowers;
        var selectedChannelFollower = channelFollowers.find(function (c) { return c.channelId === selectedChannelId; });
        if (selectedChannelFollower) {
            var others = channelFollowers.filter(function (x) { return x !== selectedChannelFollower; });
            drawnChannelFollowers = [selectedChannelFollower].concat(others);
        }
        var unselectedColorDelta = drawnChannelFollowers[0].channelId === selectedChannelId ? 1 : 0;
        var unSelectedColors = chartConfig.unselectedColors;
        return drawnChannelFollowers.map(function (c, i) {
            return {
                name: c.channelName,
                y: c.followerCount,
                customLegendDisplay: NumberUtils.normalizeNumberToString(c.followerCount),
                color: c.channelId === selectedChannelId
                    ? _this._selectedColor
                    : unSelectedColors[(i - unselectedColorDelta) % unSelectedColors.length]
            };
        });
    };
    return FollowerByChannelComponent;
}());
export { FollowerByChannelComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/follower-by-channel/follower-by-channel.component.ts.pre-build-optimizer.js